"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Export data
var _default = exports.default = {
  domain: '',
  learnMore: {
    logo: {
      alt: 'SAP Logo',
      src: '/sites/all/modules/custom_concur/concur_sap_banner/images/sap-logo.png'
    },
    text: 'Concur is an SAP Company',
    learn: {
      href: '/sap',
      text: 'Learn more'
    }
  },
  social: [{
    network: 'facebook',
    href: ''
  }, {
    network: 'twitter',
    href: ''
  }, {
    network: 'linkedin',
    href: ''
  }],
  support: {
    links: [{
      text: 'CONCUR BLOG',
      href: '/newsroom'
    }, {
      text: 'CONTACT',
      href: '/contact'
    }, {
      text: 'LEGAL DISCLOSURE',
      href: '/legal-disclosure'
    }, {
      text: 'REQUEST A QUOTE',
      href: '/get-quote-form'
    }, {
      text: 'FAQ',
      href: '/faq'
    }]
  },
  copyright: {
    text: '© Copyright @{year} Concur Technologies, Inc. All rights reserved.',
    links: [{
      text: 'Privacy Policy',
      href: '/privacy-policy'
    }, {
      text: 'Terms of Use',
      href: ''
    }, {
      text: 'Gender Pay Equality',
      href: '/pay-gap-statement'
    }]
  }
};